import React from "react";
import conf from "../../conf/conf";

export default function PrivacyPolicy() {
  const email_id = conf.email_id;

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <h1 className="text-3xl font-bold mt-24">Privacy Policy</h1>
      <p>Last updated: August 30, 2025</p>

      <p>
        Welcome to <strong>JobIntelPro</strong>. Your privacy is important to
        us. This Privacy Policy explains how we collect, use, and protect your
        information when you use our platform.
      </p>

      <h2 className="text-xl font-semibold">1. Information We Collect</h2>
      <ul className="list-disc list-inside space-y-1 text-left">
        <li>
          Personal details you provide when creating an account (name, email,
          etc.).
        </li>
        <li>Job postings or applications you submit.</li>
        <li>Usage data (pages visited, interactions, device/browser info).</li>
        <li>Cookies and similar technologies for analytics and ads.</li>
      </ul>

      <h2 className="text-xl font-semibold">2. How We Use Your Information</h2>
      <ul className="list-disc list-inside space-y-1 text-left">
        <li>To provide and improve our services.</li>
        <li>To connect job seekers with employers.</li>
        <li>To send notifications related to your activity.</li>
        <li>For analytics, personalization, and targeted advertising.</li>
      </ul>

      <h2 className="text-xl font-semibold">3. Sharing of Information</h2>
      <p className="text-left">
        We do not sell your personal data. However, we may share your
        information with:
      </p>
      <ul className="list-disc list-inside space-y-1 text-left">
        <li>Employers/recruiters when you apply for jobs.</li>
        <li>
          Service providers that support our platform (hosting, analytics, ads).
        </li>
        <li>Legal authorities if required by law.</li>
      </ul>

      <h2 className="text-xl font-semibold">4. Cookies & Ads</h2>
      <p className="text-left">
        JobIntelPro uses cookies and third-party ad services (e.g., Google Ads)
        to improve user experience and show relevant advertisements. You can
        control cookies through your browser settings.
      </p>

      <h2 className="text-xl font-semibold">5. Data Security</h2>
      <p className="text-left">
        We implement security measures to protect your data. However, no method
        of transmission over the internet is 100% secure.
      </p>

      <h2 className="text-xl font-semibold">6. Your Rights</h2>
      <p className="text-left">
        You can request access, update, or deletion of your personal data by
        contacting us at{" "}
        <strong>
          <a
            href={`mailto:${email_id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-600 hover:underline"
          >
            JobIntelPro
          </a>
        </strong>
        .
      </p>

      <h2 className="text-xl font-semibold">7. Changes to This Policy</h2>
      <p className="text-left">
        We may update this Privacy Policy from time to time. Updates will be
        posted on this page with a revised “Last updated” date.
      </p>
    </div>
  );
}
